var map = {
	"./style-attachment-grid-active.svg": "dvp0",
	"./style-attachment-grid.svg": "geNm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "534s";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/style\-attachment\-grid.*\.svg$
// module id = 534s
// module chunks = 46